import { useLocation, matchPath } from "react-router-dom";

// ----------------------------------------------------------------------

export function useActiveLink(path, deep = true) {
  const { pathname } = useLocation();

  const normalActive = path
    ? !!matchPath({ path, end: true }, pathname)
    : false;

  const deepActive = path ? !!matchPath({ path, end: false }, pathname) : false;

  // Always use deep matching for paths that contain slashes (indicating they are nested routes)
  const shouldUseDeep = deep || (path && path.includes("/") && path !== "/");

  return shouldUseDeep ? deepActive : normalActive;
}
